import { http } from './http';

/** Profil de risque investisseur courant de l'utilisateur connecté (ou null). */
export async function fetchRiskProfile() {
  const response = await http.get('/api/risk-profile/');
  return response.data?.data ?? null;
}

/** Enregistre (upsert) le profil de risque calculé à partir du questionnaire. */
export async function saveRiskProfile(payload) {
  const response = await http.post('/api/risk-profile/', payload);
  return response.data;
}
